<template>
  <div class="notice-wrap">
    <!-- 页面标题 -->
    <div class="page-title">通知管理</div>

    <!-- 搜索区域 -->
    <div class="search-section">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="通知标题">
          <el-input v-model="searchForm.title" placeholder="请输入" clearable class="search-input"></el-input>
        </el-form-item>
        <el-form-item label="发布人">
          <el-input v-model="searchForm.createUsername" placeholder="请输入" clearable class="search-input"></el-input>
        </el-form-item>
        <el-form-item label="发布时间">
          <el-date-picker
            v-model="searchTimeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            class="search-datetime"
          ></el-date-picker>
        </el-form-item>
        <el-form-item class="search-btns">
          <el-button class="btn-primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <div class="table-section">
      <div class="table-header">
        <el-button class="btn-primary" size="small" @click="openAddDialog">
          <i class="el-icon-plus"></i> 新增通知
        </el-button>
      </div>
      <el-table
        :data="tableData"
        stripe
        v-loading="loading"
        class="notice-table"
        height="100%"
      >
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column prop="title" label="通知标题" width="200" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="content" label="通知内容" min-width="300" align="left" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createUsername" label="发布人" width="120" align="center"></el-table-column>
        <el-table-column prop="publishTime" label="发布时间" width="180" align="center">
          <template slot-scope="scope">
            {{ scope.row.publishTime ? scope.row.publishTime.substring(0, 16) : '' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button type="text" class="btn-edit" @click="openEditDialog(scope.row)">编辑</el-button>
            <el-popconfirm title="您确定要删除这条通知吗？" @confirm="handleDelete(scope.row)">
              <el-button type="text" class="btn-primary-text" slot="reference">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrap">
        <div class="pagination-total">
          总计 {{ pagination.total }} 条，共 {{ Math.ceil(pagination.total / pagination.size) || 1 }} 页
        </div>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pagination.size"
          layout="sizes, prev, pager, next, jumper"
          :total="pagination.total"
        ></el-pagination>
      </div>
    </div>

    <!-- 新增/编辑弹框 -->
    <el-dialog
      :title="isEdit ? '编辑通知' : '新增通知'"
      :visible.sync="dialogVisible"
      width="700px"
      :modal="true"
      :close-on-click-modal="false"
      @close="handleDialogClose"
    >
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="通知标题" prop="title">
          <el-input v-model="form.title" placeholder="请输入" maxlength="100" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="通知内容" prop="content">
          <el-input
            type="textarea"
            v-model="form.content"
            placeholder="请输入"
            maxlength="300"
            show-word-limit
            :rows="10"
          ></el-input>
        </el-form-item>
        <el-form-item label="发布时间" prop="publishTime">
          <div class="datetime-select">
            <el-date-picker
              v-model="dateValue"
              type="date"
              placeholder="请选择日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              style="width: 100%;"
            ></el-date-picker>
            <el-time-picker
              v-model="timeValue"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="请选择时间"
              style="width: 100%;"
            ></el-time-picker>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button class="btn-save" type="primary" @click="handleSave">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  notificationDelete,
  notificationDetail,
  notificationAdd,
  notificationEdit,
  notificationList,
} from "@/api/notification";

export default {
  name: "noticeManagement",
  data() {
    return {
      loading: false,
      dialogVisible: false,
      isEdit: false,
      tableData: [],
      searchForm: {
        title: "",
        createUsername: "",
      },
      searchTimeRange: [],
      form: {
        id: "",
        title: "",
        content: "",
        publishTime: "",
      },
      // 日期和时间分开存储，便于独立选择
      dateValue: "",
      timeValue: "",
      pagination: {
        page: 1,
        size: 10,
        total: 0,
      },
      rules: {
        title: [
          { required: true, message: "请输入通知标题", trigger: "blur" },
        ],
        content: [
          { required: true, message: "请输入通知内容", trigger: "blur" },
        ],
        publishTime: [
          { required: true, message: "请选择发布时间", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    // 合并日期和时间
    publishTimeComputed: {
      get() {
        if (this.dateValue && this.timeValue) {
          return `${this.dateValue} ${this.timeValue}`;
        }
        return "";
      },
      set(val) {
        if (val) {
          const arr = val.split(" ");
          this.dateValue = arr[0] || "";
          this.timeValue = arr[1] || "";
        } else {
          this.dateValue = "";
          this.timeValue = "";
        }
      },
    },
  },
  watch: {
    // 监听 dateValue 和 timeValue 变化，更新 form.publishTime（传给后端带秒）
    dateValue(val) {
      if (val && this.timeValue) {
        this.form.publishTime = `${val} ${this.timeValue}:00`;
      } else {
        this.form.publishTime = "";
      }
    },
    timeValue(val) {
      if (this.dateValue && val) {
        this.form.publishTime = `${this.dateValue} ${val}:00`;
      } else {
        this.form.publishTime = "";
      }
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 获取列表数据
    async getList() {
      this.loading = true;
      const params = {
        page: this.pagination.page,
        size: this.pagination.size,
        ...this.searchForm,
        startPublishTime: this.searchTimeRange ? this.searchTimeRange[0] : "",
        endPublishTime: this.searchTimeRange ? this.searchTimeRange[1] : "",
      };
      try {
        const res = await notificationList(params);
        if (res.data.code === 200) {
          this.tableData = res.data.data.records || [];
          this.pagination.total = Number(res.data.data.total) || 0;
        } else {
          this.$message.error(res.data.msg || "查询失败");
        }
      } catch (error) {
        console.error(error);
        this.$message.error("网络异常，请重试");
      } finally {
        this.loading = false;
      }
    },

    // 查询
    onSearch() {
      this.pagination.page = 1;
      this.getList();
    },

    // 重置
    onReset() {
      this.searchForm = {
        title: "",
        createUsername: "",
      };
      this.searchTimeRange = [];
      this.pagination.page = 1;
      this.getList();
    },

    // 分页
    handleSizeChange(val) {
      this.pagination.size = val;
      this.pagination.page = 1;
      this.getList();
    },

    handleCurrentChange(val) {
      this.pagination.page = val;
      this.getList();
    },

    // 新增
    openAddDialog() {
      this.isEdit = false;
      this.form = {
        id: "",
        title: "",
        content: "",
        publishTime: "",
      };
      this.dialogVisible = true;
    },

    // 编辑
    async openEditDialog(row) {
      this.isEdit = true;
      this.form.id = row.id;
      try {
        const res = await notificationDetail({ id: row.id });
        if (res.data.code === 200) {
          const data = res.data.data;
          this.form = {
            id: data.id,
            title: data.title,
            content: data.content,
            publishTime: data.publishTime,
          };
          // 解析发布时间，分别设置日期和时间
          if (data.publishTime) {
            const arr = data.publishTime.split(" ");
            this.dateValue = arr[0] || "";
            // timeValue 去掉秒的部分（如 14:30:00 -> 14:30）
            this.timeValue = arr[1] ? arr[1].substring(0, 5) : "";
          } else {
            this.dateValue = "";
            this.timeValue = "";
          }
          this.dialogVisible = true;
        } else {
          this.$message.error(res.data.msg || "获取详情失败");
        }
      } catch (error) {
        console.error(error);
        this.$message.error("网络异常，请重试");
      }
    },

    // 弹框关闭
    handleDialogClose() {
      this.$refs.form && this.$refs.form.resetFields();
      this.form = {
        id: "",
        title: "",
        content: "",
        publishTime: "",
      };
      this.dateValue = "";
      this.timeValue = "";
    },

    // 保存
    handleSave() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            let res;
            if (this.isEdit) {
              res = await notificationEdit(this.form);
            } else {
              res = await notificationAdd(this.form);
            }
            if (res.data.code === 200) {
              this.$message.success(this.isEdit ? "编辑成功" : "新增成功");
              this.dialogVisible = false;
              this.getList();
            } else {
              this.$message.error(res.data.msg || "操作失败");
            }
          } catch (error) {
            console.error(error);
            this.$message.error("网络异常，请重试");
          }
        }
      });
    },

    // 删除
    async handleDelete(row) {
      try {
        const res = await notificationDelete({ id: row.id });
        if (res.data.code === 200) {
          this.$message.success("已删除");
          this.getList();
        } else {
          this.$message.error(res.data.msg || "删除失败");
        }
      } catch (error) {
        console.error(error);
        this.$message.error("网络异常，请重试");
      }
    },
  },
};
</script>

<style scoped lang="less">
// ========== 变量定义 ==========
@main-color: #0054FE;
@primary-color: #409EFF;
@text-primary: #494C4F;
@text-regular: #606266;
@text-secondary: #909399;
@border-color: #DCDFE6;
@bg-color: #F1F4F6;

// ========== 页面容器 ==========
.notice-wrap {
  background: #fff;
  padding: 20px 24px;
  height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
}

// ========== 页面标题 ==========
.page-title {
  font-family: MiSans;
  font-size: 20px;
  font-weight: 500;
  color: @text-primary;
  margin-bottom: 15px;
}

// ========== 搜索区域 ==========
.search-section {
  margin-bottom: 24px;

  .search-form {
    margin: 0;

    .el-form-item {
      margin-bottom: 0;
      margin-right: 24px;
    }

    .el-form-item__label {
      font-family: MiSans;
      font-size: 16px;
      font-weight: 400;
      color: #494C4F;
    }

    /deep/ .el-range-input{
      font-size: 16px;
      color: #606266;
    }

    .search-input {
      width: 215px;
    }

    .search-datetime {
      width: 380px;
    }

    .search-btns {
      margin-left: 16px;
    }
  }
}

// ========== 主色按钮 ==========
.btn-primary {
  background-color: @main-color !important;
  border-color: @main-color !important;
  color: #fff !important;

  &:hover {
    background-color: lighten(@main-color, 10%) !important;
    border-color: lighten(@main-color, 10%) !important;
  }
}

// ========== 弹框保存按钮 ==========
.btn-save {
  background-color: @main-color !important;
  border-color: @main-color !important;
  color: #fff !important;

  &:hover {
    background-color: lighten(@main-color, 10%) !important;
    border-color: lighten(@main-color, 10%) !important;
  }
}

// ========== 表格区域 ==========
.table-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .table-header {
    flex-shrink: 0;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 16px;
  }

  .notice-table {
    flex: 1;
    /deep/ th {
      background: @bg-color;
      font-family: MiSans;
      font-size: 16px;
      font-weight: 500;
      color: #494C4F;
    }
    /deep/ td{
      font-family: MiSans;
      font-size: 16px;
      font-weight: 400;
      color: #494C4F;
    }
    /deep/ .el-table__row--striped td.el-table__cell{
      background: #F7FAFF;
    }

    .btn-edit {
      color: #0495FF;
      padding: 0 8px;

      &:hover {
        color: #0495FF;
      }
    }

    .btn-primary-text {
      color: #EB3538;
      padding: 0 8px;

      &:hover {
        color: #EB3538;
      }
    }
  }

  .pagination-wrap {
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;
  }

  .pagination-total {
    font-size: 14px;
    color: @text-regular;
  }
}

// ========== 日期时间选择器 ==========
.datetime-select {
  display: flex;
  gap: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/AuthenticationAuthority/userManagement/noticeManagement.vue